;(function () {
  angular
    .module('contrast.applications-archive')
    .controller(
      'AppArchiveModalInstanceCtrl',
      function (
        $scope,
        $routeParams,
        $uibModalInstance,
        $translate,
        logger,
        ErrorService,
        ApplicationFactory,
        applications
      ) {
        'ngInject'

        angular.extend($scope, {
          modules: angular.copy(applications),
          orgUuid: $routeParams.orgUuid
        })

        angular.extend($scope, {
          archive: function () {
            var transl = {
              detail_archivePrimaryApplication_appsArchivedSuccessfully:
                $translate.instant(
                  'detail_archivePrimaryApplication_appsArchivedSuccessfully'
                )
            }

            ApplicationFactory.archiveBatch($scope.modules).then(
              function () {
                logger.logSuccess(
                  transl.detail_archivePrimaryApplication_appsArchivedSuccessfully
                )
                $uibModalInstance.close()
              },
              function (response) {
                ErrorService.processError(response)
              }
            )
          },

          cancel: function () {
            $uibModalInstance.dismiss('cancel')
          }
        })
      }
    )
})()
